var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_2260)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5029 0.909645C8.77224 0.705687 8.08797 0.926171 7.60169 1.37299C7.12295 1.81289 6.83331 2.4703 6.83331 3.17371V7.63671C6.83331 8.48166 7.51828 9.16663 8.36324 9.16663H12.8262C13.5296 9.16663 14.1871 8.877 14.627 8.39825C15.0738 7.91198 15.2943 7.2277 15.0903 6.49705C14.3356 3.79331 12.2066 1.66438 9.5029 0.909645ZM7.83331 3.17371C7.83331 2.7395 8.01339 2.35275 8.27829 2.10934C8.53566 1.87286 8.86896 1.77091 9.23404 1.87282C11.6008 2.5335 13.4664 4.39913 14.1271 6.76591C14.229 7.13099 14.1271 7.46429 13.8906 7.72166C13.6472 7.98656 13.2604 8.16663 12.8262 8.16663H8.36324C8.07057 8.16663 7.83331 7.92938 7.83331 7.63671V3.17371Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78153 3.14366C6.04498 3.06091 6.19147 2.78026 6.10873 2.51681C6.02598 2.25336 5.74533 2.10686 5.48188 2.18961C2.78819 3.03565 0.833313 5.55192 0.833313 8.52607C0.833313 12.1936 3.80639 15.1666 7.47387 15.1666C10.448 15.1666 12.9643 13.2118 13.8103 10.5181C13.8931 10.2546 13.7466 9.97396 13.4831 9.89122C13.2197 9.80847 12.939 9.95496 12.8563 10.2184C12.1374 12.5073 9.99876 14.1666 7.47387 14.1666C4.35868 14.1666 1.83331 11.6413 1.83331 8.52607C1.83331 6.00119 3.49264 3.86256 5.78153 3.14366Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_2260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.c0a0af9411660c401d095797f257919d.svg";
export { ForwardRef as ReactComponent };